import { createSelector } from '@reduxjs/toolkit';
import { MaxResultsListState } from 'ducks/max-results-list/slices';
import { RootState } from 'store';

const maxResultsListSlice = (state: RootState) => state.max_results_list;

export const selectMaxResultsList = createSelector([maxResultsListSlice], (state): MaxResultsListState[] => state);
